import { Link } from "react-router-dom";
import { Stethoscope, ArrowRight, Quote, HeartHandshake, ShieldCheck } from "lucide-react";
import PageWrapper from "@/components/layout/PageWrapper";
import Breadcrumb from "@/components/Breadcrumb";
import { useLanguage } from "@/i18n/LanguageContext";
import { IMAGES, CONTACT } from "@/data/content";

const Doctor = () => {
  const { t } = useLanguage();
  return (
    <PageWrapper
      title={`${t("doctor.name")} — Consultant, Bhadrak Physiotherapy`}
      description="Dr. Manas Ranjan Jena — Consultant and Parent Counselor at Bhadrak Physiotherapy & Rehab Centre."
    >
      <section className="adhd-container pt-10 lg:pt-14">
        <Breadcrumb pageKey="nav.doctor" />
      </section>

      <section className="adhd-container mt-8 grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        <div className="lg:col-span-5">
          <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden border border-[color:var(--adhd-border)]">
            <img
              src="/doctor.jpeg"
              alt={t("doctor.name")}
              decoding="async"
              className="h-full w-full object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="adhd-eyebrow">
            <Stethoscope size={13} /> {t("doctor.title")}
          </p>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight text-[color:var(--adhd-text)]">
            {t("doctor.name")}
          </h1>
          <p className="mt-2 text-[color:var(--adhd-muted)] text-lg">{t("doctor.role")}</p>

          <p className="mt-6 text-[16px] leading-relaxed text-[color:var(--adhd-text)]/85">
            {t("doctor.description")}
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            <div className="adhd-card p-5">
              <span className="grid place-items-center h-10 w-10 rounded-xl" style={{ background: "rgba(58,124,165,0.10)" }}>
                <HeartHandshake size={18} style={{ color: "var(--adhd-primary)" }} />
              </span>
              <p className="mt-3 font-serif text-lg text-[color:var(--adhd-text)]">Patient-First Philosophy</p>
              <p className="mt-1.5 text-sm text-[color:var(--adhd-muted)] leading-relaxed">
                Listening before prescribing. Every plan is built around what the patient — and the family — actually needs.
              </p>
            </div>
            <div className="adhd-card p-5">
              <span className="grid place-items-center h-10 w-10 rounded-xl" style={{ background: "rgba(90,147,103,0.18)" }}>
                <ShieldCheck size={18} style={{ color: "var(--adhd-success)" }} />
              </span>
              <p className="mt-3 font-serif text-lg text-[color:var(--adhd-text)]">Holistic Rehabilitation</p>
              <p className="mt-1.5 text-sm text-[color:var(--adhd-muted)] leading-relaxed">
                Combining physiotherapy, parent counselling and steady follow-up for outcomes that last.
              </p>
            </div>
          </div>

          <blockquote
            className="mt-8 relative adhd-card-soft p-8 italic text-lg leading-relaxed"
          >
            <Quote
              size={28}
              className="absolute -top-3 -left-3 opacity-30"
              style={{ color: "var(--adhd-primary)" }}
            />
            "We believe healing begins with being heard. Every patient — every parent — deserves time, dignity and a plan built just for them."
          </blockquote>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/contact" data-testid="doctor-book" className="adhd-btn-primary">
              Book Consultation <ArrowRight size={14} />
            </Link>
            <a href={`tel:${CONTACT.phoneTel}`} className="adhd-btn-secondary" data-testid="doctor-call">
              {t("cta.call")}
            </a>
          </div>
        </div>
      </section>
    </PageWrapper>
  );
};

export default Doctor;
